import { render } from "./EnrolleePlanEditOnboardComponent.vue?vue&type=template&id=c0aceff6&scoped=true"
import script from "./EnrolleePlanEditOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleePlanEditOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleePlanEditOnboardComponent.vue?vue&type=style&index=0&id=c0aceff6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0aceff6"]])

export default __exports__